module.exports = __webpack_public_path__ + "static/media/UBS.643dde83.png";